var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/CommonEventsList/CommonEventsList.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/CommonEventsList/CommonEventsList.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data", "title", "isPopup", "isIndex", "isClasses", "perItemAnimation"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});frame.set("title", Object.prototype.hasOwnProperty.call(kwargs, "title") ? kwargs["title"] : "");frame.set("isPopup", Object.prototype.hasOwnProperty.call(kwargs, "isPopup") ? kwargs["isPopup"] : false);frame.set("isIndex", Object.prototype.hasOwnProperty.call(kwargs, "isIndex") ? kwargs["isIndex"] : false);frame.set("isClasses", Object.prototype.hasOwnProperty.call(kwargs, "isClasses") ? kwargs["isClasses"] : false);frame.set("perItemAnimation", Object.prototype.hasOwnProperty.call(kwargs, "perItemAnimation") ? kwargs["perItemAnimation"] : false);var t_5 = "";t_5 += "\n    <div class=\"CommonEventsList";
if(runtime.contextOrFrameLookup(context, frame, "isPopup") || runtime.contextOrFrameLookup(context, frame, "isClasses")) {
t_5 += " CommonEventsList--popup";
;
}
t_5 += " ";
if(runtime.contextOrFrameLookup(context, frame, "isIndex")) {
t_5 += " CommonEventsList--index";
;
}
if(runtime.contextOrFrameLookup(context, frame, "isClasses")) {
t_5 += " CommonEventsList--classes";
;
}
t_5 += "\">\n        ";
if(runtime.contextOrFrameLookup(context, frame, "title")) {
t_5 += "<h3>";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "title"), env.opts.autoescape);
t_5 += "</h3>";
;
}
t_5 += "\n        <ul class=\"CommonEventsList-events\">\n        ";
frame = frame.push();
var t_8 = runtime.contextOrFrameLookup(context, frame, "data");
if(t_8) {t_8 = runtime.fromIterator(t_8);
var t_7 = t_8.length;
for(var t_6=0; t_6 < t_8.length; t_6++) {
var t_9 = t_8[t_6];
frame.set("event", t_9);
frame.set("loop.index", t_6 + 1);
frame.set("loop.index0", t_6);
frame.set("loop.revindex", t_7 - t_6);
frame.set("loop.revindex0", t_7 - t_6 - 1);
frame.set("loop.first", t_6 === 0);
frame.set("loop.last", t_6 === t_7 - 1);
frame.set("loop.length", t_7);
t_5 += "<li>\n                ";
if(runtime.contextOrFrameLookup(context, frame, "isPopup")) {
t_5 += "\n                  ";
t_5 += "\n\n                ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "isClasses")) {
t_5 += "\n                      <div class=\"CommonEventsList-event\" ";
if(runtime.contextOrFrameLookup(context, frame, "perItemAnimation")) {
t_5 += "data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" data-animation-delay=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") * 100, env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += ">\n                        <div class=\"CommonEventsList-eventDate\">\n                            ";
if(runtime.memberLookup((t_9),"date")) {
t_5 += "\n                                <div class=\"CommonEventsList-eventDay\">";
t_5 += runtime.suppressValue(env.getFilter("datetime").call(context, runtime.memberLookup((t_9),"date"),"%d"), env.opts.autoescape);
t_5 += "</div>\n                                <div class=\"CommonEventsList-eventMonth\">";
t_5 += runtime.suppressValue(env.getFilter("datetime").call(context, runtime.memberLookup((t_9),"date"),"%b"), env.opts.autoescape);
t_5 += "</div>\n                            ";
;
}
else {
t_5 += "\n                                <div class=\"CommonEventsList-eventTBD\">TBD</div>\n                            ";
;
}
t_5 += "\n                        </div>\n                        <div class=\"CommonEventsList-eventTitle\">";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"title"), env.opts.autoescape);
t_5 += "</div>\n                        <div class=\"CommonEventsList-eventDetails\">\n                            ";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"timeFormatted"), env.opts.autoescape);
if(runtime.memberLookup((t_9),"place")) {
t_5 += ": ";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"place"), env.opts.autoescape);
;
}
t_5 += "\n                        </div>\n                        ";
if(runtime.memberLookup((t_9),"calendar")) {
t_5 += "\n                            <div class=\"CommonEventsList-eventAdd\">\n                                <a href=\"";
t_5 += runtime.suppressValue((lineno = 39, colno = 60, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((t_9),"calendar")),"url"), "event[\"calendar\"][\"url\"]", context, [])), env.opts.autoescape);
t_5 += "\">add to calendar</a>\n                            </div>\n                        ";
;
}
t_5 += "\n                    </div>\n                ";
;
}
else {
t_5 += "\n                    <a class=\"CommonEventsList-event\" href=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"url"), env.opts.autoescape);
t_5 += "\" ";
if(runtime.contextOrFrameLookup(context, frame, "perItemAnimation")) {
t_5 += "data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" data-animation-delay=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") * 50, env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += ">\n                        <div class=\"CommonEventsList-eventDate\">\n                            ";
if(runtime.memberLookup((t_9),"date")) {
t_5 += "\n                                <div class=\"CommonEventsList-eventDay\">";
t_5 += runtime.suppressValue(env.getFilter("datetime").call(context, runtime.memberLookup((t_9),"date"),"%d"), env.opts.autoescape);
t_5 += "</div>\n                                <div class=\"CommonEventsList-eventMonth\">";
t_5 += runtime.suppressValue(env.getFilter("datetime").call(context, runtime.memberLookup((t_9),"date"),"%b"), env.opts.autoescape);
t_5 += "</div>\n                            ";
;
}
else {
t_5 += "\n                                <div class=\"CommonEventsList-eventTBD\">TBD</div>\n                            ";
;
}
t_5 += "\n                        </div>\n                        <div class=\"CommonEventsList-eventTitle\">";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"title"), env.opts.autoescape);
t_5 += "</div>\n                        <div class=\"CommonEventsList-eventDetails\">";
if(runtime.contextOrFrameLookup(context, frame, "isIndex")) {
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"sectionTitle"), env.opts.autoescape);
if(runtime.memberLookup((t_9),"short") != "&nbsp;") {
t_5 += ": ";
;
}
;
}
t_5 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_9),"short")), env.opts.autoescape);
t_5 += "</div>\n                        <div class=\"CommonEventsList-eventArrow\">\n                            ";
t_5 += runtime.suppressValue((lineno = 56, colno = 50, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["arrow-list","0 0 140 64",runtime.makeKeywordArgs({"caller": (function (){var macro_t_10 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_11 = "";;
frame = frame.pop();
return new runtime.SafeString(t_11);
});
return macro_t_10;})()})])), env.opts.autoescape);
t_5 += "\n                        </div>\n                    </a>\n                ";
;
}
;
}
t_5 += "\n            </li>\n        ";
;
}
}
frame = frame.pop();
t_5 += "\n        </ul>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("CommonEventsList");
context.setVariable("CommonEventsList", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/CommonEventsList/CommonEventsList.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/CommonEventsList/CommonEventsList.jinja
// module id = 42
// module chunks = 0